/* eslint-disable */
import React, { useState } from "react";
// @material-ui/core components
import {
  Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Search from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { RemoveRedEye } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import { db, auth } from "../../Firebase/firebase.js";
import multiColumnSort from "multi-column-sort";
import ls from "local-storage";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { isEqual } from "date-fns";
const useStyles = makeStyles(styles);

export default function MyFish() {
  const theme = useTheme();
  const classes = useStyles();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));

  /////////Other hooks//////////
  //Seach
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  //View
  const [viewflag, setviewflag] = React.useState(false);
  //Table Row Data
  const [rows, setRows] = React.useState([]);
  const [fishRows, setFishRows] = React.useState([]);
  const [testRows, setTestRows] = React.useState([
    {
      docId: "74WfmcyvPfgr04H6WfPw",
      name: "Khadija",
      email: "khadijahakk99@gmail.com",
      dob: "15/07/1999",
      address: "dfsf",
      contact: "2312412",
    },
  ]);

  ////////Handling data change////////
  const [fishType, setFishType] = React.useState("Brook Trout");
  const [currentDocID, setCurrentDocID] = React.useState("");

  //Handling Rankings Dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (row) => {
    ls.set("currentDocID", row.docId);
    ls.set("fishType", "Brook Trout");
    getRanking();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  //Table Style
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  //Get data (Read)
  var getRegistrations = () => {
    let newArray = [];
    db.collection("eventRegistration")
      .where("uid", "==", ls.get("currentcustomerUid"))
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRows(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  const getColumnValue = (column, value) => {
    switch (column) {
      case "balance":
        return parseFloat(value.replace(/\,|\$/g, ""));
      default:
        return value;
    }
  };

  var getRanking = () => {
    let newArray = [];
    db.collection("fishRegistration")
      .doc(ls.get("fishType"))
      .collection(ls.get("fishType"))
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        //multisort
        let newArray1 = multiColumnSort(
          newArray,
          {
            weight: "DESC",
            length: "DESC",
          },
          getColumnValue
        );
        let newArray2 = [];
        for (let i = 0; i < newArray1.length; i++) {
          if (newArray1[i].registrationId == ls.get("currentDocID")) {
            newArray2.push({ index: i + 1, fish: newArray1[i] });
          }
        }
        setFishRows(newArray2);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };

  var handleFishTypeChange = (e) => {
    ls.set("fishType", e.target.value);
    setFishType(e.target.value);
    getRanking();
  };

  React.useEffect(() => {
    if (ls.get("currentcustomerUid") === "") {
    } else {
      getRegistrations();
    }
  }, []);

  //Search fisherman
  const searchRegistration = () => {
    if (searchflag === true) {
      let newArray = [];
      db.collection("eventRegistration")
        .where("name", ">=", searchref.current.value)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            newArray.push(doc.data());
          });
          setRows(newArray);
          setsearchflag(false);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    } else {
      searchref.current.value = "";
      getFishermen();
      setsearchflag(true);
    }
  };

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "495px" : "80px" }}>
            <TextField
              placeholder="Search"
              variant="outlined"
              inputRef={searchref}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={searchRegistration}>
                      {searchflag ? <SearchIcon /> : <ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </GridItem>
      </GridContainer>
      <Box pb={3} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{ height: 450, overflow: "scroll", display: "inline-block" }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: "20%" }}
                    className={(classes.tableheadercell, classes.tablehead)}
                  >
                    Registration ID
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Name
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Email
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    DOB
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Address
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Contact Number
                  </TableCell>
                  <TableCell
                    className={(classes.tableheadercell, classes.tablehead)}
                    align="left"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.docId}>
                    <TableCell
                      //  onClick={() => viewFisherman(row)}
                      //   style={{ color: "blue" }}
                      component="th"
                      scope="row"
                    >
                      {row.docId}
                    </TableCell>

                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.dob}</TableCell>
                    <TableCell align="left">{row.address}</TableCell>
                    <TableCell align="left">{row.contact}</TableCell>
                    <TableCell align="left">
                      <div>
                        <IconButton onClick={() => handleClickOpen(row)}>
                          <Link style={{ fontSize: 15 }}>View Ranking</Link>
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <Dialog
            open={open}
            maxWidth="xl"
            onClose={handleClose}
            //fullScreen="true"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="event-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
                <h5 style={{ display: "inline-block" }}>Fish</h5>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 600, width: 600 }}>
              <FormControl
                variant="filled"
                style={{ width: mobileratio ? 267 : 530 }}
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Fish Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={fishType}
                  onChange={handleFishTypeChange}
                >
                  <MenuItem value="Brook Trout">Brook Trout</MenuItem>
                  <MenuItem value="Cusk">Cusk</MenuItem>
                  <MenuItem value="Largest Perch">Largest Perch</MenuItem>
                  <MenuItem value="Most Perch">Most Perch</MenuItem>
                  <MenuItem value="Muskie">Muskie</MenuItem>
                  <MenuItem value="Salmon">Salmon</MenuItem>
                  <MenuItem value="Togue">Togue</MenuItem>
                </Select>
              </FormControl>
              {mobileratio ? <br></br> : <br></br>}
              {fishRows.map((row) => (
                <Box m={3} pt={5}>
                  <Card
                    className={classes.root}
                    style={{ backgroundColor: "#171942" }}
                  >
                    <CardActionArea>
                      <CardMedia
                        style={{ height: 0, paddingTop: "56%" }}
                        image={row.fish.image}
                      />
                      <CardContent>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h2"
                          style={{ color: "white", fontWeight: "bold" }}
                        >
                          Rank: {row.index}
                        </Typography>
                        <h5
                          style={{
                            display: "inline-block",
                            fontWeight: "lighter",
                            fontSize: 18,
                            color: "white",
                          }}
                        >
                          Fish Weight: {row.fish.weight}
                        </h5>
                        <br></br>
                        <h5
                          style={{
                            display: "inline-block",
                            fontWeight: "lighter",
                            fontSize: 18,
                            color: "white",
                          }}
                        >
                          Fish Length: {row.fish.length}
                        </h5>
                        <br></br>
                        <h5
                          style={{
                            display: "inline-block",
                            fontWeight: "lighter",
                            fontSize: 18,
                            color: "white",
                          }}
                        >
                          Catch Date: {row.fish.DateTime.substring(0, 10)}
                        </h5>
                        <br></br>
                        <h5
                          style={{
                            display: "inline-block",
                            fontWeight: "lighter",
                            fontSize: 18,
                            color: "white",
                          }}
                        >
                          Catch Time: {row.fish.DateTime.substring(11, 19)}
                        </h5>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Box>
              ))}
            </DialogContent>
            <DialogActions></DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>
    </>
  );
}
